/**
 * What the wizard calls the customer's three-digit number. The one place the wording is set: every label, hint, message and
 * Review row reads it from here. The state key, API field and payload key stay `customerNumber` / `customer_number`, so the
 * backend and stored deployments are unaffected.
 */
export const CUSTOMER_CODE_LABEL = 'Customer Code'

/** The same words inside a sentence: "Enter a customer code (100–999)". */
export const CUSTOMER_CODE_IN_TEXT = CUSTOMER_CODE_LABEL.toLowerCase()
